/*
 * @Author: M.D.
 * @Date: 2020-01-10 13:39:18
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
import request from './axios'
import request1 from './axios1'
// import _ from 'lodash'

export default {
  //查询申报支付记录
  getShenbaoPay: data => {
    return request({
      url: '/order/tGoods/cxsbzfjl',
      method: 'POST',
      data
    })
  },
  //登录机器人
  hqdlyzm: data => {
    return request({
      url: '/order/com/hqdlyzm',
      method: 'POST',
      data
    })
  },
  //一键申报
  qqsbkk: data => {
    return request({
      url: '/order/com/qqsbkk',
      //url: '/com/qqsbkk',
      method: 'POST',
      data
    })
  },
  //查询申报记录
  cxsbjl: data => {
    return request({
      url: '/order/tGoods/cxsbjl',
      method: 'POST',
      data
    })
  },
  //查询风险评估支付记录
  cxfxpgzfjl: data => {
    return request({
      url: '/order/tGoods/cxfxpgzfjl',
      //url: '/order/tGoods/cxfxpgzfjl_1',
      method: 'POST',
      data
    })
  },
  //请求风险评估qqfxpg
  qqfxpg: data => {
    return request({
      url: '/order/com/qqfxpg',
      method: 'POST',
      data
    })
  },
  //查询风险评估记录cxfxpgjl
  cxfxpgjl: data => {
    return request({
      url: '/order/tGoods/cxfxpgjl',
      method: 'POST',
      data
    })
  },
  //获取登录验证码状态
  hqdlyzmzt: data => {
    return request({
      url: '/order/com/hqdlyzmzt',
      method: 'POST',
      data
    })
  },
}
